import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=646e5438&scoped=true&"
import script from "./CampaignDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e5438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646e5438')) {
      api.createRecord('646e5438', component.options)
    } else {
      api.reload('646e5438', component.options)
    }
    module.hot.accept("./CampaignDetail.vue?vue&type=template&id=646e5438&scoped=true&", function () {
      api.rerender('646e5438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Marketing/CampaignDetail.vue"
export default component.exports